module.exports = __webpack_public_path__ + "static/media/tutorial_browse.623bab15.png";